import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { recommendationApi } from 'farmx-api';
import { actions } from 'farmx-redux-core';

const { updateNewBlockItem } = actions;

export function useRecommendationRefreshStatus(blockId) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!blockId) {
      return undefined;
    }

    let isMounted = true;

    async function retrieveRefreshStatus() {
      try {
        const response = await recommendationApi
          .retrieveRecommendationMetadataRefreshStatus({ blockId });
        const {
          blockId: responseBlockId,
          recommendationRefresh,
        } = response?.data || {};

        if (isMounted && responseBlockId && recommendationRefresh) {
          dispatch(updateNewBlockItem({
            id: responseBlockId,
            changes: { recommendationRefresh },
          }));
        }
      } catch {
        // Recommendation details remain usable when refresh status is unavailable.
      }
    }

    retrieveRefreshStatus();

    return () => {
      isMounted = false;
    };
  }, [blockId, dispatch]);
}
